import { TaskStore } from '../../core/task-store.js';
import { Task } from '../../types/index.js';
import { ExtendedTask } from '../../types/extended-task.js';

export class TaskService {
  private taskStore: TaskStore;

  constructor(workflowDir?: string) {
    this.taskStore = new TaskStore(workflowDir);
  }

  async list(): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasks();
  }

  async get(id: string): Promise<ExtendedTask | null> {
    const task = await this.taskStore.getTaskById(id);
    return task || null;
  }

  async create(taskData: Partial<Task> | Partial<ExtendedTask>): Promise<ExtendedTask> {
    return await this.taskStore.addTask(taskData);
  }

  async update(id: string, updates: Partial<Task> | Partial<ExtendedTask>): Promise<ExtendedTask> {
    const updated = await this.taskStore.updateTask(id, updates);
    if (!updated) {
      throw new Error('Task not found');
    }
    return updated;
  }

  async delete(id: string): Promise<void> {
    const success = await this.taskStore.deleteTask(id);
    if (!success) {
      throw new Error('Task not found');
    }
  }
  
  // 新增：扩展任务方法
  async getExtended(id: string): Promise<ExtendedTask | null> {
    const task = await this.taskStore.getExtendedTaskById(id);
    return task || null;
  }
  
  async getByPrdId(prdId: string): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasksByPrdId(prdId);
  }
  
  async getByDesignId(designId: string): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasksByDesignId(designId);
  }
  
  async getByWorkflowId(workflowId: string): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasksByWorkflowId(workflowId);
  }
  
  async getByAgent(agentName: string): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasksByAgent(agentName);
  }
  
  async getByTechStack(tech: string): Promise<ExtendedTask[]> {
    return await this.taskStore.getTasksByTechStack(tech);
  }
}